const isValidLuhnNumber = (cardNumberPrefix, cardNumber) => {
  const CARD_NUMBER_VALIDATION_REG = new RegExp("^\\d{10}$");
  const PREFIX_NUMBER_VALIDATION_REG = new RegExp("^\\d{6}$");
  if (!PREFIX_NUMBER_VALIDATION_REG.exec(cardNumberPrefix.trim())?.length) {
    console.error("card prefix validation failed");
    return false;
  }
  if (!CARD_NUMBER_VALIDATION_REG.exec(cardNumber.trim())?.length) {
    console.error("card number validation failed");
    return false;
  }
  const CHECK_SUM = Number(cardNumber.at(-1));
  const cardNumbers = (cardNumberPrefix + cardNumber.substring(0, cardNumber.length - 1)).split("").map(Number).reverse();
  let sum = 0;
  cardNumbers.forEach((item, index) => {
    if (!(index % 2)) {
      sum = item > 4 ? sum + (2 * item - 9) : sum + 2 * item;
    } else {
      sum = sum + item;
    }
  });
  return CHECK_SUM == (sum % 10 ? 10 - sum % 10 : 0);
};
export {
  isValidLuhnNumber
};
//# sourceMappingURL=is-valid-luhn-number.js.map
